import NextImage from 'next/image'
import { useTranslations } from 'next-intl'

export const ProductCard = ({ item, handleClick, mobileColumns = 3, isSelected = false }: any) => {
  const t = useTranslations()
  const label = item.label ? t(item.label) : item.shortName?.content?.text || ''
  const imageSrc = item.imageSrc || item.images?.content?.images?.[0]?.url || item.defaultVariant?.firstImage?.url
  const imageAlt = label
  const mobileWidthClassName =
    mobileColumns === 2
      ? 'min-w-[calc((100%-10px)/2)] max-w-[calc((100%-10px)/2)]'
      : 'min-w-[calc((100%-20px)/3)] max-w-[calc((100%-20px)/3)]'

  return (
    <div
      className={`flex min-h-[160px] ${mobileWidthClassName} flex-col flex-wrap items-center justify-center gap-3 rounded border border-[#F3F2E9] bg-[#F3F2E9] p-[5px] hover:cursor-pointer sm:min-h-[200px] sm:min-w-[150px] sm:max-w-[167px] sm:gap-5 [&.selected]:border-black [&.selected]:bg-white ${isSelected ? 'selected' : ''}`}
      onClick={(e) => handleClick(item, e)}
    >
      <div className="h-14 w-14 sm:h-20 sm:w-20">
        {imageSrc ? (
          <NextImage src={imageSrc} alt={imageAlt} width={80} height={80} className="h-full w-full object-contain" />
        ) : null}
      </div>
      <div>
        <span className="mx-auto block leading-none">{label}</span>
        <span className="block text-center font-bold leading-none">
          {item.volume || item.shortDescription?.content?.text}
        </span>
      </div>
    </div>
  )
}
